import { Box, Grid, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { EMAIL_SUPPORT, PHONE_SUPPORT } from "../services/Constants";

export default function Footer() {
  return (
    <Box bgcolor="#2B241C" color="#fff" py={6} mt={10}>
      <Grid container spacing={4} px={8}>
        <Grid item md={4}>
          <Typography variant="h4">RK Farm</Typography>
          <Typography variant="h6">
            Premium organic vermicompost and vermiwash.
          </Typography>
        </Grid>

        <Grid item md={4}>
          <Typography variant="h6">Quick Links</Typography>
          <Typography>
            <Link to="/products" style={{ color: "inherit", textDecoration: "none" }}>
              Products
            </Link>
          </Typography>
          <Typography>
            <Link to="/benefits" style={{ color: "inherit", textDecoration: "none" }}>
              Benefits
            </Link>
          </Typography>
          <Typography>
            <Link to="/contact" style={{ color: "inherit", textDecoration: "none" }}>
              Contact
            </Link>
          </Typography>
        </Grid>

        <Grid item md={4}>
          <Typography variant="h6">{PHONE_SUPPORT}</Typography>
          <Typography>{EMAIL_SUPPORT}</Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
